export default __webpack_public_path__ + "static/cheer-bottles-vertical-4423106309e45601df28b6b23c5a9642.png";